import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        ////定义属性， 进行状态管理
        menuActiveName: 'home',
        cartTotal: 0,
        msgTotal: 0,
        pageInfo: null
    },
    mutations: {
        //同步请求方法
        updateMenuActiveName(state, name) {
            state.menuActiveName = name;
        },
        updateCartTotal(state, num) {
            state.cartTotal = num;
        },
        updateMsgTotal(state, num) {
            state.msgTotal = num;
        },
        updatePageInfo(state, info) {
            state.pageInfo = info;
        }
    },
    actions: {
        //异步请求方法
    },
    modules: {}
});